<div class="header">
    <h5>
      Address Details
      <ng-container *ngIf="selectedObjectRecord?.statusId !=2">
        <span *ngIf="allowEdit" class="btnBars p-mr-0" style="position: relative; float: right" (click)="addNewAddress()">
          <i class="pi pi-plus"></i>
        </span>
      </ng-container>
    </h5>
  </div>
  <div class="card">
    <p-table [value]="currentAddressList" styleClass="p-datatable-gridlines">
      <ng-template pTemplate="header">
        <tr *ngIf="(moduleId === accountModuleId || moduleId === leadModuleId) && checkedFields; else elseTrRows">
          <th>Type</th>
          <th> Address Class </th>
          <th *ngIf="checkedFields.StreetAddress1"> {{checkedFields.StreetAddress1.labelName}} </th>
          <th *ngIf="checkedFields.StreetAddress2"> {{checkedFields.StreetAddress2.labelName}} </th>
          <th *ngIf="checkedFields.City" >{{checkedFields.City.labelName}} </th>
          <th *ngIf="checkedFields.State"> {{checkedFields.State.labelName}} </th>
          <th *ngIf="checkedFields.Country"> {{checkedFields.Country.labelName}} </th>
          <th *ngIf="checkedFields.Zip"> {{checkedFields.Zip.labelName}} </th>
          <th *ngIf="checkedFields.Attn"> {{checkedFields.Attn.labelName}} </th>
          <th *ngIf="checkedFields.AddressName"> Address Name </th>
          <th style="width: 80px"> Is Active </th>
          <th style="width: 85px"> Is Default </th>
        </tr>
        <ng-template #elseTrRows>
          <tr>
            <th>Type</th>
            <th> Address Class </th>
            <th *ngIf="currentLabels[0] ? currentLabels[0].ischecked == true : null">{{currentLabels[0] ?
              currentLabels[0].labelname : null}}</th>
            <th *ngIf="currentLabels[1] ? currentLabels[1].ischecked == true : null">{{currentLabels[1] ?
              currentLabels[1].labelname : null}}</th>
            <th *ngIf="currentLabels[4] ? currentLabels[4].ischecked == true : null">{{currentLabels[4] ?
              currentLabels[4].labelname : null}}</th>
            <th *ngIf="currentLabels[3] ? currentLabels[3].ischecked == true : null">{{currentLabels[3] ?
              currentLabels[3].labelname : null}}</th>
            <th *ngIf="currentLabels[2] ? currentLabels[2].ischecked == true : null">{{currentLabels[2] ?
              currentLabels[2].labelname : null}}</th>
            <th *ngIf="currentLabels[5] ? currentLabels[5].ischecked == true : null">{{currentLabels[5] ?
              currentLabels[5].labelname : null}}</th>
            <th *ngIf="currentLabels[6] ? currentLabels[6].ischecked == true : null">{{currentLabels[6] ?
              currentLabels[6].labelname : null}}</th>
            <th style="width: 80px">Is Active</th>
            <th style="width: 85px">Is Default</th>
          </tr>
        </ng-template>
      </ng-template>
      <ng-template pTemplate="body" let-addressObj let-index="rowIndex">
        <tr [pSelectableRow]="addressObj" *ngIf="(moduleId === accountModuleId || moduleId === leadModuleId) && checkedFields;
          else elseTrData" [pSelectableRowIndex]="rowIndex">
          <td [class.pointer]="currentAllowEditValue" (click)="selectedObjectRecord?.statusId !=2 ? editAddress(addressObj, index) : null">
            <ng-container *ngIf="selectedObjectRecord?.statusId !=2">
              <i *ngIf="currentAllowEditValue" class="pi pi-pencil address-edit-icon"></i>
              </ng-container>
               {{ addressObj.address.addressType?.name }}
          </td>
          <td> {{ addressObj.address.addressClass?.name }} </td>
          <td *ngIf="checkedFields.StreetAddress1">{{ addressObj.address?.streetAddress1 }}</td>
          <td *ngIf="checkedFields.StreetAddress2">{{ addressObj.address?.streetAddress2 }}</td>
          <td *ngIf="checkedFields.City">{{ addressObj.address?.city?.name }}</td>
          <td *ngIf="checkedFields.State">{{ addressObj.address?.state?.name }}</td>
          <td *ngIf="checkedFields.Country">{{ addressObj.address?.country?.name }}</td>
          <td *ngIf="checkedFields.Zip">{{ addressObj.address?.zipCode }}</td>
          <td *ngIf="checkedFields.Attn">{{ getContactName(addressObj) }}</td>
          <td *ngIf="checkedFields.AddressName"> {{ addressObj.address.addressName }} </td>
          <td class="action p-text-center">
            <p-inputSwitch class="header-switch" [disabled]="!currentAllowEditValue || addressObj.address.isDefault || selectedObjectRecord?.statusId ===2"
              [(ngModel)]="addressObj.address.statusId" (onChange)="handleChange(addressObj)" [trueValue]="1"
              [falseValue]="2"></p-inputSwitch>
          </td>
          <td class="action p-text-center">
            <p-radioButton [value]="true" [disabled]="!currentAllowEditValue || selectedObjectRecord?.statusId ===2" [(ngModel)]="addressObj.address.isDefault"
              (onClick)="setDefaultAddr(addressObj, index)">
            </p-radioButton>
          </td>
        </tr>
        <ng-template #elseTrData>
          <tr [pSelectableRow]="addressObj" [pSelectableRowIndex]="rowIndex">
            <td [class.pointer]="currentAllowEditValue" (click)="selectedObjectRecord?.statusId !=2 ? editAddress(addressObj, index): null">
              {{ addressObj.address.addressType?.name }}
            </td>
            <td> {{ addressObj.address.addressClass?.name }} </td>
            <td *ngIf="currentLabels[0] ? currentLabels[0].ischecked == true : null">{{ addressObj.address?.streetAddress1
              }}</td>
            <td *ngIf="currentLabels[1] ? currentLabels[1].ischecked == true : null">{{ addressObj.address?.streetAddress2
              }}</td>
            <td *ngIf="currentLabels[4] ? currentLabels[4].ischecked == true : null">{{ addressObj.address?.city?.name }}
            </td>
            <td *ngIf="currentLabels[3] ? currentLabels[3].ischecked == true : null">{{ addressObj.address?.state?.name }}
            </td>
            <td *ngIf="currentLabels[2] ? currentLabels[2].ischecked == true : null">{{ addressObj.address?.country?.name
              }}
            </td>
            <td *ngIf="currentLabels[5] ? currentLabels[5].ischecked == true : null">{{ addressObj.address?.zipCode }}
            </td>
            <td *ngIf="currentLabels[6] ? currentLabels[6].ischecked == true : null">{{ getContactName(addressObj) }}</td>
            <td class="action p-text-center">
              <p-inputSwitch class="header-switch" [disabled]="!currentAllowEditValue || addressObj.address.isDefault || selectedObjectRecord?.statusId === 2"
                [(ngModel)]="addressObj.address.statusId" (onChange)="handleChange()" [trueValue]="1"
                [falseValue]="2"></p-inputSwitch>
            </td>
            <td class="action p-text-center">
              <p-radioButton [value]="true" [disabled]="!currentAllowEditValue || selectedObjectRecord?.statusId === 2" [(ngModel)]="addressObj.address.isDefault"
                (onClick)="setDefaultAddr(addressObj, index)">
              </p-radioButton>
            </td>
          </tr>
        </ng-template>
      </ng-template>
    </p-table>
  </div>

  <app-lion-add-edit-address-modal [currentAddressList]="currentAddressList" [countries]="countries"
    [accountAddressTypes]="accountAddressTypes" [addressClasses]="addressClasses" [fieldLabels]="currentLabels"
    [display]="showAddAddress" [addressHeader]="header" [isAddAddress]="isAddAddress" [addressObj]="addressTemp"
    [editAddressIndex]="editAddressIndex" [selectedObjectRecord]="currentSelectedObjectRecord" [addressName]="addressNameValue" [moduleId]="moduleId"
    [contactListAttnList]="currentContactListAttn" [mappingField]="currentMappingField" [checkedFields]="checkedFields" [overViewPage]="overViewPage"
    (onCancelAddAddress)="cancelAddaddress($event)" (onAddAddress)="onAddAddress($event)"
    (onUpdateAddressList)="onUpdateAddress()">
  </app-lion-add-edit-address-modal>
